import { Box, Stack } from '@chakra-ui/core';
import React from 'react';
import PositionTable from './PositionTable';
import { useStoreState } from '../../../../../models/hooks';

function PositionsViewComponent() {
  const { isBulkAssignMode } = useStoreState((state) => state.moniterByRecruiters);
  return (
    <Box
      flexGrow={1}
      height="-webkit-fill-available"
      borderRadius="md"
      bg="white"
      p={4}
      borderTopRadius={0}
      borderBottomRadius={isBulkAssignMode ? 0 : 'md'}
    >
      <Stack spacing={4}>
        {/* <PositionHeader /> */}
        <Box flexGrow={1}>
          <PositionTable />
        </Box>
      </Stack>
    </Box>
  );
}

export const PositionsView = React.memo(PositionsViewComponent);
